var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.event)?_c('div',{staticClass:"message"},[_vm._v("Ends at "+_vm._s(_vm._f("datetime")(_vm.event.sale_time.end,_vm.time_format)))]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }